var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('transition',{attrs:{"name":"pagefade","mode":"out-in"}},[_c('router-view',{on:{"identified":_vm.setIdentified,"logout":_vm.logout,"openingDossier":_vm.openingDossier}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }